import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ReturnUrlService } from '../services/return-url.service';
import { map, take } from 'rxjs/operators';

export const parentAuthGuard: CanActivateFn = (route, state: RouterStateSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const returnUrlService = inject(ReturnUrlService);

  return auth.isLoggedIn$.pipe(
    take(1),
    map(isLoggedIn => {
      if (isLoggedIn && auth.getCurrentRole() === 'parent') {
        return true;
      }

      // Only save returnUrl on the "not logged in" case, not on
      // "logged in but wrong role" — a wrong-role user redirected to
      // login and back would just bounce into the guard again.
      if (!isLoggedIn) {
        returnUrlService.setReturnUrl(state.url);
      }

      return router.createUrlTree(['/login']);
    })
  );
};